export default class Toggle {
  constructor(btn, target) {
    this.btn = $(btn);
    this.target = $(target);
  }
  toggleNext(speed = 200) {
    this.btn.on('click', eventObject => {
      const windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      if (windowWidth > 640) {
          return
      } else {
        $(eventObject.currentTarget).toggleClass('is_open');
        $(eventObject.currentTarget).next().slideToggle(speed);
      }
    })
  }
}
